import React, { useState, useRef } from "react";
import "./Mid-Section.scss";

import ViewPaymentsSelectCard from "./ViewPaymentsSelectCard";
import RecentPaymentsCards from "../../OverView/Mobile-and-Tablet/RecentPaymentsCards";

//import icons
import { ReactComponent as CalenderIcon } from "../../../assets/icons/custom-calender-icon.svg";
import { FaAngleDown } from "react-icons/fa6";

// Import images from the assets folder
import imageSource1 from "../../../assets/images/abstract-4.png";
import imageSource2 from "../../../assets/images/abstract-5.png";
import PendingIncoicesCard from "../../OverView/Mobile-and-Tablet/PendingIncoicesCard";
import MonthYearPicker from "./MonthPicker";
// import PayWindowModal from "./PayWindowModal";

const MidSectionPayments = () => {
  //payment popup
  const [showPay, setShowPay] = useState(false);

  //index of select cards
  const [currentIndex, setCurrentIndex] = useState(0);
  const sliderRef = useRef(null);

  const cardWidth = 162; // Width of each card in pixels
  const gapWidth = 10; // Gap between cards in pixels

  const moveToCard = (index) => {
    setCurrentIndex(index);
    const totalScrollLeft = index * (cardWidth + gapWidth);
    sliderRef.current.scrollLeft = totalScrollLeft;
  };

  return (
    <div className="mid-section-payments">
      <div className="title">View select</div>
      <div className="view-payment-select-container">
        <div className="slider-container" ref={sliderRef}>
          <div className="slider">
            {[
              {
                Title: "View All Payments",
                Ammount: "ksh.10,000",
                SubText: "Payments Made",
                imageLink: imageSource1,
                colorOfIcon: "192A3A",
                setBackgroundSizeAndPosition: ["auto", "left top"],
              },
              {
                Title: "Approve Payments",
                Ammount: "5",
                SubText: "Payment Aproval",
                imageLink: imageSource2,
                colorOfIcon: "192A3A",
                setBackgroundSizeAndPosition: ["500% 110%", "center left"],
              },
              {
                Title: "View invoices and make payments",
                Ammount: "ksh10,000",
                SubText: "Payments Made",
                imageLink: imageSource2,
                colorOfIcon: "192A3A",
                setBackgroundSizeAndPosition: ["500% 110%", "center left"],
              },
            ].map((card, index) => (
              <button
                key={index}
                className="payment-card-button"
                onClick={() => moveToCard(index)}
              >
                <ViewPaymentsSelectCard
                  Title={card.Title}
                  Ammount={card.Ammount}
                  SubText={card.SubText}
                  imageLink={card.imageLink}
                  colorOfIcon={card.colorOfIcon}
                  setBackgroundSizeAndPosition={
                    card.setBackgroundSizeAndPosition
                  }
                />
              </button>
            ))}
          </div>
        </div>
      </div>
      {currentIndex === 0 && (
        <>
          <div className="recentPayments">
            <div className="title recent-payments">Recent payments</div>
            <RecentPaymentsCards />
          </div>
        </>
      )}
      {currentIndex === 1 && (
        <>
          <div className="recentPayments">
            <div className="title recent-payments">
              Payments Pending Aproval
            </div>
            <RecentPaymentsCards />
          </div>
        </>
      )}
      {currentIndex === 2 && (
        <>
          <div className="recentPayments">
            <div className="make-payment">Make Payment</div>
            <div className="date-and-property">
              <MonthYearPicker />
              <div className="apartment">
                <select
                  id="apartment-select"
                  name="apartment"
                  className="apartment-dropdown"
                >
                  <option value="apartment1">Apartment 1</option>
                  <option value="apartment2">Apartment 2</option>
                  <option value="apartment3">Apartment 3</option>
                </select>
              </div>
            </div>

            <PendingIncoicesCard />
          </div>
        </>
      )}

      {/* {showPay && <>
        <div className="modal">
          <PayWindowModal setShowPay={setShowPay} fieldToShow={ false} />
      </div> 
      </>} */}
    </div>
  );
};

export default MidSectionPayments;
